import React from "react";

/** Dynamic SDK is not bundled. Children keep the default session, which cannot connect. */
export const DynamicWalletProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => <>{children}</>;
